/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargo_Select_WarehouseInputs */

const en_cargo_select_warehouse = /** @type {(inputs: Cargo_Select_WarehouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select warehouse`)
};

const es_cargo_select_warehouse = /** @type {(inputs: Cargo_Select_WarehouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecciona almacen`)
};

/**
* | output |
* | --- |
* | "Select warehouse" |
*
* @param {Cargo_Select_WarehouseInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargo_select_warehouse = /** @type {((inputs?: Cargo_Select_WarehouseInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargo_Select_WarehouseInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargo_select_warehouse(inputs)
	return es_cargo_select_warehouse(inputs)
});